/*
 * @Description:
 * @Author: yangshuaibing
 * @Date: 2023-12-13 11:13:38
 * @LastEditors: likk 1126919170@qq.com
 * @LastEditTime: 2024-05-10 14:48:04
 * @FilePath: \info.xiangli360.com\src\utils\vant.config.js
 */
// 需要那个,引入那个
import {
  Field,
  Toast,
  Search,
  Cell,
  CellGroup,
  Icon,
  Button,
  Sticky,
  Form,
  Popup,
  Picker,
  Switch,
  Area,
  DatetimePicker,
  Loading,
  Tab,
  Tabs,
  Dialog,
  PullRefresh,
  Image as VanImage,
  List,
  Cascader,
  Uploader,
  IndexBar,
  IndexAnchor,
  Checkbox,
  CheckboxGroup
} from "vant";
export function vant(app) {
  //注册
  app.use(Field);
  app.use(Toast);
  app.use(Search);
  app.use(Cell);
  app.use(CellGroup);
  app.use(Icon);
  app.use(Button);
  app.use(Sticky);
  app.use(Form);
  app.use(Popup);
  app.use(Picker);
  app.use(Switch);
  app.use(Area);
  app.use(DatetimePicker);
  app.use(Dialog);
  app.use(Tab);
  app.use(Tabs);
  app.use(Loading);
  app.use(PullRefresh);
  app.use(VanImage);
  app.use(List);
  app.use(Cascader);
  app.use(Uploader);
  app.use(IndexBar);
  app.use(IndexAnchor);
  app.use(Checkbox);
  app.use(CheckboxGroup);
}
